import { KeyboardArrowDown } from 'emotion-icons/material'
import * as React from 'react'
import MegaMenu from './MegaMenu'

const RenderNavItems = ({ navData, featuredContent = null, Link = null }) => {
  const linkDeterminer = (item) => {
    const link = item?.link || item?.href

    const hasSubnav =
      item.subnav &&
      (Array.isArray(item.subnav) ? item.subnav.length > 0 : true)
    if (hasSubnav) {
      return (
        <Link to={item.href}>
          <span>{item.text}</span> <KeyboardArrowDown size={18} />
        </Link>
      )
    }
    return link ? (
      <Link to={link}>
        <span>{item.text}</span>
      </Link>
    ) : (
      <span>{item.text}</span>
    )
  }

  const megaMenuDeterminer = (item) => {
    // For payload: use MegaMenu if any subitem has megaLinks
    const isPayloadMegaMenu =
      item?.subnav &&
      Array.isArray(item.subnav) &&
      item.subnav.some(
        (subitem) => subitem?.megaLinks && subitem.megaLinks.length > 0
      )
    // For Contentful: use MegaMenu if megaMenu flag is set
    if ((item.megaMenu && item.subnav) || isPayloadMegaMenu) {
      return (
        <MegaMenu data={item} featuredContent={featuredContent} Link={Link} />
      )
    }
    if (item.subnav) {
      return (
        <ul className="subnav">
          {item.subnav.map((subitem) => (
            <li key={subitem.text}>
              <Link to={subitem?.href || subitem.link}>{subitem.text}</Link>
            </li>
          ))}
        </ul>
      )
    }
    return null
  }

  return (
    <>
      {navData.map((item) => (
        <span key={item.text} className="primary-link">
          {linkDeterminer(item)}
          {megaMenuDeterminer(item)}
        </span>
      ))}
    </>
  )
}

export default RenderNavItems
